import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { SketchPicker } from 'react-color'
import IconButton from 'material-ui/IconButton';
import ActionColor from 'material-ui/svg-icons/image/lens';
import styled from 'styled-components';
import {Flex} from 'rebass';

class SketchColorPicker extends Component{
  constructor(props){
    super(props);
    this.state = {
      displayColorPicker: false,
      color:props.color,
      result: props.color
    }
  }
  handleClick = () => {
    this.setState({ displayColorPicker: !this.state.displayColorPicker })
  }

  handleClose = () => {
    this.setState({ displayColorPicker: false })
  }

  handleChange = (color) => {
    let {rgb} = color;
    let newColor = `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${rgb.a})`;
    this.setState({ color: color.rgb, result : newColor});
  }
  handleChangeComplete = (color, event) => {
    let {rgb} = color;
    let newColor = `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${rgb.a})`;
    this.props.onUpdateColor(newColor);
  }
  componentWillReceiveProps(nextProps){
    if(this.props.color !== nextProps.color){
      this.setState({ color: nextProps.color, result : nextProps.color});
    }
  }

  render(){
    const {title} = this.props;
    return(
      <Flex w={[1]} direction={["column"]}>
        <Flex w={[1]} direction={["row"]}>
        <Title>{title}</Title>
        <IconButton onClick={this.handleClick} style={styles.iconButton} iconStyle={{ width:36, height:36, border: '2px solid #DAD1D1', borderRadius: '18px'}} >
          <ActionColor color={this.state.result} />
        </IconButton>
        </Flex>
        { this.state.displayColorPicker ? <div style={ styles.popover }>
          <div style={ styles.cover } onClick={ this.handleClose }/>
          <SketchPicker color={ this.state.color } onChange={ this.handleChange } onChangeComplete={ this.handleChangeComplete }  />
        </div> : null }
      </Flex>
    )
  }
}

const styles = {
    swatch: {
      padding: '5px',
      background: '#fff',
      borderRadius: '1px',
      boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
      display: 'inline-block',
      cursor: 'pointer',
    },
    popover: {
      position: 'relative',
      zIndex: '2',
      paddingTop:10
    },
    cover: {
      position: 'fixed',
      top: '0px',
      right: '0px',
      bottom: '0px',
      left: '0px',
    },
    iconButton:{
      width:72,
      height:72
    }
}

const Title = styled.span`
  align-items: center;
  display: flex;
`;


SketchColorPicker.propTypes = {
  title:PropTypes.string,
  color: PropTypes.string,
  onUpdateColor : PropTypes.func.isRequired
};
//
SketchColorPicker.defaultProps = {
  color:'#4A90E2',
  title: 'Background Color '
};


export default SketchColorPicker;



// WEBPACK FOOTER //
// ./src/editor/components/colorpicker/SketchColorPicker.js